(function(){

    'use strict';

    // Grab all the buttons
    var animalDetailsButtons = document.querySelectorAll('.animal-details__button'),
        viewContactsButton = document.querySelector('.animal-details__button--view-contacts'),
        stepThreeUrl;

    if(viewContactsButton) {
        stepThreeUrl = viewContactsButton.getAttribute('href');
    }
    if(animalDetailsButtons.length > 0){
        for (let animalDetailsButton of animalDetailsButtons) {

            animalDetailsButton.addEventListener('click', (event) => {
                event.preventDefault();
                let parent = animalDetailsButton.parentNode.parentNode;
                let selected = parent.querySelector('.animal-details__button--selected');
                let controls = animalDetailsButton.getAttribute('aria-controls');
    
                if (animalDetailsButton != selected) {
                    if (selected) {
                        // Deselect the selected button
                        selected.classList.remove('animal-details__button--selected');
                    }
                    // Select the clicked button
                    animalDetailsButton.classList.add('animal-details__button--selected');
    
                    // Get the value of the animal condition selected
                    setAnimalCondition(animalDetailsButton);
    
                    if (controls) {
                        controls = controls.split(' ');
                        for (let present of document.querySelectorAll('.present')) {
                            present.classList.remove('present');
                            present.classList.add('awaiting');
                        }
                        for (let control of controls) {
                            document.querySelector(`#${control}`).classList.remove('awaiting');
                            document.querySelector(`#${control}`).classList.add('present');
                        }
                    }
                }

                if(event.target.hasAttribute("data-animalstate")) {
                    document.cookie = "animalState=" + event.target.getAttribute("data-animalstate");
                    document.cookie = "animalType=" + document.getElementById('animal-details-initial').getAttribute("data-animaltype");
                }

                // Scroll to element
                $('html, body').animate({
                    scrollTop: $(event.target.hash).offset().top
                }, 360, 'linear');
            });
        }
    }
    

    function setAnimalType() {
        // Get the value of the animal type via the URL
        let urlParams = new URLSearchParams(window.location.search);
        let animalCautionMessage = document.querySelector('.animal-details__caution');
        let animalCautionMessageSpanFirst = document.querySelector('.animal-details__caution span:first-of-type');

        if (urlParams.has('animal') && viewContactsButton) {
            let animalType = urlParams.get('animal');
            //set the view contacts button to capture the animal type
            viewContactsButton.setAttribute('data-animal-type', animalType);
            animalCautionMessage.setAttribute('data-animal-type', animalType);
            animalCautionMessageSpanFirst.innerHTML = '';
            animalCautionMessageSpanFirst.innerHTML += animalType;
        }
    }

    // setAnimalType();

    function setAnimalCondition(animalDetailsButton) {
        // Get the value of the animal condition selected
        if (animalDetailsButton.hasAttribute("data-animal-condition")) {
            let animalCondition = animalDetailsButton.getAttribute('data-animal-condition'),
                animalConditionMessage = animalDetailsButton.getAttribute('data-condition-message'),
                animalShowContacts = animalDetailsButton.getAttribute('data-show-contacts'),
                animalCautionMessage = document.querySelector('.animal-details__caution'),
                animalCautionMessageSpan = document.querySelector('.animal-details__caution span:last-of-type'),
                animalDetailsViewContacts = document.querySelector('#animal-details-view-contacts');

            // Set cookie
            document.cookie = "animalCondition=" + animalCondition;

            // set the view contacts button to capture the animal condition
            // viewContactsButton.setAttribute('data-animal-condition', animalCondition);
            viewContactsButton.setAttribute('href', stepThreeUrl + '&animal-condition=' + animalCondition);
            // animalCautionMessage.setAttribute('data-animal-condition', animalCondition);

            // Proceed to contacts
            if(animalShowContacts) {
                animalDetailsViewContacts.classList.add('show-message');
            }
            else {
                animalDetailsViewContacts.classList.remove('show-message');
            }

            animalCautionMessage.classList.remove('show-message');
            animalCautionMessageSpan.innerHTML = '';

            // If theres a warning message show it
            if(animalConditionMessage) {
                animalCautionMessage.classList.add('show-message');
                animalCautionMessageSpan.innerHTML += animalConditionMessage;
            }

        }
    }
    
    // Set button states
    // if(getCookie("animalState")) {
    //     // we don't want to simulate the click if the animal type is different to a previous page visit
    //     let animalState = getCookie("animalState"),
    //         animalStateButtons = document.querySelectorAll('[data-animalstate]'),
    //         animalTypeCookie = getCookie("animalType"),
    //         animalTypeToMatch = document.getElementById('animal-details-initial').getAttribute("data-animaltype"),
    //         animalTypeMatch = false;
        
    //     if(animalTypeCookie === animalTypeToMatch){
    //         animalTypeMatch = true;
    //     }

    //     var simulateClick = function (elem) {
    //       	// Create our event (with options)
    //       	var evt = new MouseEvent('click', {
    //       		  bubbles: true,
    //       		  cancelable: true,
    //       		  view: window
    //       	});
    //       	// If cancelled, don't dispatch our event
    //       	var canceled = !elem.dispatchEvent(evt);
    //     };

    //     // Set animal state
    //     for(let button of animalStateButtons) {
    //         let stateValue = button.getAttribute('data-animalstate');

    //         if(stateValue == animalState) {
    //             if(animalTypeMatch){
    //                 simulateClick(button);
    //             }
    //         }
    //     }

    //     // Set animal condition
    //     if(getCookie("animalCondition")) {
    //         let animalCondition = getCookie("animalCondition"),
    //             animalConditionButtons = document.querySelectorAll('[data-animal-condition]');

    //         for(let button of animalConditionButtons) {
    //             let conditionValue = button.getAttribute('data-animal-condition');

    //             if(animalCondition == conditionValue) {
    //                 simulateClick(button);
    //             }
    //         }
    //     }
    // }

}());
